export default __webpack_public_path__ + "static/logo-min-4f202e1ade06ece60a40a11550f2ccdf.png";